module.exports = new __parcel__URL__("NoProductAccess.a1396ea1.svg").toString();